<template>
  <div></div>
</template>

<script>
import { mapMutations } from 'vuex'
export default {
  name: "redirection",
  methods: {
    ...mapMutations({
      setIsIframe: 'setIsIframe',
    }),
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      const token = vm.$route.query.token;
      const isIframe = vm.$route.query.isIframe;
      if (isIframe) {
        vm.setIsIframe(true);
      }
      window.location = "/api/loginController/runAs?token=" + token
    })
  }
};
</script>
<style scoped></style>
